import axios from "axios";

export function getClassTemplateList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ClassTemplate/getlist", config);
}

export function getScheduleChoise(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ClassTemplate/ScheduleChoise", config);
}

export function postClassTemplate(data) {
  return axios.post(process.env.VUE_APP_API_URL + "ClassTemplate/add", data);
}

export function updateClassTemplate(data) {
  return axios.put(process.env.VUE_APP_API_URL + "ClassTemplate/update", data);
}

export function deleteClassTemplate(classTemplateId) {
  const config = {
    params: {
      classTemplateId: classTemplateId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "ClassTemplate/delete", config);
}
